import { z } from "zod/v4";

export const SuggestionStatusValue = {
  error: 3,
  info: 1,
  ok: 0,
  warning: 2,
};

export type SuggestionStatus = keyof typeof SuggestionStatusValue;

export type SuggestionStatusValue =
  (typeof SuggestionStatusValue)[keyof typeof SuggestionStatusValue];

export function getSuggestionStatus(
  value?: SuggestionStatusValue,
): keyof typeof SuggestionStatusValue | undefined {
  return Object.keys(SuggestionStatusValue).find(
    (key) =>
      SuggestionStatusValue[key as keyof typeof SuggestionStatusValue] ===
      value,
  ) as SuggestionStatus;
}

export function getSuggestionStatusValue(
  status?: SuggestionStatus,
): SuggestionStatusValue | undefined {
  if (!status) return undefined;
  return SuggestionStatusValue[status];
}

export const sortBySchema = z.enum(["bestChoice", "size"]);

export type SuggestionsSortBy = z.infer<typeof sortBySchema>;
